export const MUSIC_PATH = 'resource/audio/export/music/';

/* prettier-ignore */ export const AUDIO_LEVEL_PARIS = MUSIC_PATH + 'Paris_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_BALI = MUSIC_PATH + 'Beach_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_ITALY = MUSIC_PATH + 'Italy_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_JAPAN = MUSIC_PATH + 'Japan_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_ICELAND = MUSIC_PATH + 'Iceland_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_AUSTRALIA = MUSIC_PATH + 'Underwater_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_EGYPT = MUSIC_PATH + 'Egypt_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_ARIZONA = MUSIC_PATH + 'Arizona_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_AUSTRIA = MUSIC_PATH + 'Forest_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_TANZANIA = MUSIC_PATH + 'Forest_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_BERLIN = MUSIC_PATH + 'Italy_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_CAMBODIA = MUSIC_PATH + 'Japan_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_ENGLAND = MUSIC_PATH + 'Italy_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_CANADA = MUSIC_PATH + 'Forest_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_BRAZIL = MUSIC_PATH + 'Japan_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_RUSSIA = MUSIC_PATH + 'Italy_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_CALIFORNIA = MUSIC_PATH + 'Beach_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_POLAND = MUSIC_PATH + 'Forest_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_ARGENTINA = MUSIC_PATH + 'Forest_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_TURKEY = MUSIC_PATH + 'Egypt_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_GREECE = MUSIC_PATH + 'Beach_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_CUBA = MUSIC_PATH + 'Italy_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_SPAIN = MUSIC_PATH + 'Italy_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_KOREA = MUSIC_PATH + 'Italy_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_UKRAINE = MUSIC_PATH + 'Forest_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_CHILE = MUSIC_PATH + 'Forest_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_INDIA = MUSIC_PATH + 'Forest_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_FRENCHRIVIERA = MUSIC_PATH + 'Beach_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_NORWAY = MUSIC_PATH + 'Iceland_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_NEWZEALAND = MUSIC_PATH + 'Forest_Ingame_Sound.mp3';
/* prettier-ignore */ export const AUDIO_LEVEL_MADAGASCAR = MUSIC_PATH + 'Egypt_Ingame_Sound.mp3';

export const AUDIO_LEVEL: string[] = [
    AUDIO_LEVEL_PARIS,
    AUDIO_LEVEL_BALI,
    AUDIO_LEVEL_ITALY,
    AUDIO_LEVEL_JAPAN,
    AUDIO_LEVEL_ICELAND,
    AUDIO_LEVEL_AUSTRALIA,
    AUDIO_LEVEL_EGYPT,
    AUDIO_LEVEL_ARIZONA,
    AUDIO_LEVEL_AUSTRIA,
    AUDIO_LEVEL_TANZANIA,
    AUDIO_LEVEL_BERLIN,
    AUDIO_LEVEL_CAMBODIA,
    AUDIO_LEVEL_ENGLAND,
    AUDIO_LEVEL_CANADA,
    AUDIO_LEVEL_BRAZIL,
    AUDIO_LEVEL_RUSSIA,
    AUDIO_LEVEL_CALIFORNIA,
    AUDIO_LEVEL_POLAND,
    AUDIO_LEVEL_ARGENTINA,
    AUDIO_LEVEL_TURKEY,
    AUDIO_LEVEL_GREECE,
    AUDIO_LEVEL_CUBA,
    AUDIO_LEVEL_SPAIN,
    AUDIO_LEVEL_KOREA,
    AUDIO_LEVEL_UKRAINE,
    AUDIO_LEVEL_CHILE,
    AUDIO_LEVEL_INDIA,
    AUDIO_LEVEL_FRENCHRIVIERA,
    AUDIO_LEVEL_NORWAY,
    AUDIO_LEVEL_NEWZEALAND,
    AUDIO_LEVEL_MADAGASCAR,
];

/* prettier-ignore */ export const AUDIO_WORLD_PARIS = MUSIC_PATH + 'Paris_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_BALI = MUSIC_PATH + 'Beach_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_ITALY = MUSIC_PATH + 'Italy_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_JAPAN = MUSIC_PATH + 'Japan_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_ICELAND = MUSIC_PATH + 'Iceland_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_AUSTRALIA = MUSIC_PATH + 'Underwater_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_EGYPT = MUSIC_PATH + 'Egypt_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_ARIZONA = MUSIC_PATH + 'Arizona_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_AUSTRIA = MUSIC_PATH + 'Austria_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_TANZANIA = MUSIC_PATH + 'Tanzania_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_BERLIN = MUSIC_PATH + 'Berlin_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_CAMBODIA = MUSIC_PATH + 'Japan_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_ENGLAND = MUSIC_PATH + 'Austria_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_CANADA = MUSIC_PATH + 'Canada_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_BRAZIL = MUSIC_PATH + 'Brazil_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_RUSSIA = MUSIC_PATH + 'Russia_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_CALIFORNIA = MUSIC_PATH + 'California_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_POLAND = MUSIC_PATH + 'Poland_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_ARGENTINA = MUSIC_PATH + 'Argentina_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_TURKEY = MUSIC_PATH + 'Egypt_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_GREECE = MUSIC_PATH + 'Italy_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_CUBA = MUSIC_PATH + 'Argentina_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_SPAIN = MUSIC_PATH + 'Brazil_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_KOREA = MUSIC_PATH + 'Korea_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_UKRAINE = MUSIC_PATH + 'Poland_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_CHILE = MUSIC_PATH + 'Argentina_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_INDIA = MUSIC_PATH + 'Japan_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_FRENCHRIVIERA = MUSIC_PATH + 'Paris_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_NORWAY = MUSIC_PATH + 'Iceland_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_NEWZEALAND = MUSIC_PATH + 'Canada_Map_Music.mp3';
/* prettier-ignore */ export const AUDIO_WORLD_MADAGASCAR = MUSIC_PATH + 'Tanzania_Map_Music.mp3';

export const AUDIO_WORLD: string[] = [
    AUDIO_WORLD_PARIS,
    AUDIO_WORLD_BALI,
    AUDIO_WORLD_ITALY,
    AUDIO_WORLD_JAPAN,
    AUDIO_WORLD_ICELAND,
    AUDIO_WORLD_AUSTRALIA,
    AUDIO_WORLD_EGYPT,
    AUDIO_WORLD_ARIZONA,
    AUDIO_WORLD_AUSTRIA,
    AUDIO_WORLD_TANZANIA,
    AUDIO_WORLD_BERLIN,
    AUDIO_WORLD_CAMBODIA,
    AUDIO_WORLD_ENGLAND,
    AUDIO_WORLD_CANADA,
    AUDIO_WORLD_BRAZIL,
    AUDIO_WORLD_RUSSIA,
    AUDIO_WORLD_CALIFORNIA,
    AUDIO_WORLD_POLAND,
    AUDIO_WORLD_ARGENTINA,
    AUDIO_WORLD_TURKEY,
    AUDIO_WORLD_GREECE,
    AUDIO_WORLD_CUBA,
    AUDIO_WORLD_SPAIN,
    AUDIO_WORLD_KOREA,
    AUDIO_WORLD_UKRAINE,
    AUDIO_WORLD_CHILE,
    AUDIO_WORLD_INDIA,
    AUDIO_WORLD_FRENCHRIVIERA,
    AUDIO_WORLD_NORWAY,
    AUDIO_WORLD_NEWZEALAND,
    AUDIO_WORLD_MADAGASCAR,
];

/* prettier-ignore */ export const AUDIO_LEVEL_INTRO_CARDS = 'Cards_Added_LevelStart';
/* prettier-ignore */ export const AUDIO_LEVEL_FAILED = 'level_loss_popup_music';
/* prettier-ignore */ export const AUDIO_CARD_FOLD = 'Cardplay';
/* prettier-ignore */ export const AUDIO_CARD_STREAK_1 = 'rising_tones1';
/* prettier-ignore */ export const AUDIO_CARD_STREAK_2 = 'rising_tones2';
/* prettier-ignore */ export const AUDIO_CARD_STREAK_3 = 'rising_tones3';
/* prettier-ignore */ export const AUDIO_CARD_STREAK_4 = 'rising_tones4';
/* prettier-ignore */ export const AUDIO_CARD_STREAK_5 = 'rising_tones5';
/* prettier-ignore */ export const AUDIO_CARD_STREAK_6 = 'rising_tones6';
/* prettier-ignore */ export const AUDIO_CARD_STREAK_7 = 'rising_tones7';
/* prettier-ignore */ export const AUDIO_CARD_STREAK_8 = 'rising_tones8';
/* prettier-ignore */ export const AUDIO_CARD_STREAK_9 = 'rising_tones9';
/* prettier-ignore */ export const AUDIO_CARD_STREAK_10 = 'rising_tones10';
/* prettier-ignore */ export const AUDIO_CARD_STREAK_BONUS_1 = 'cardstreak_1';
/* prettier-ignore */ export const AUDIO_CARD_STREAK_BONUS_2 = 'cardstreak_2_3';
/* prettier-ignore */ export const AUDIO_WILDCARD_PLUS_THREE = 'cardplus3';
/* prettier-ignore */ export const AUDIO_WILDCARD_PLUS_THREE_DECK = 'cardplus3deck';
/* prettier-ignore */ export const AUDIO_WILDCARD_BOOM = 'boom_240119';
/* prettier-ignore */ export const AUDIO_WILDCARD_ZAP = 'ZapElectrocute';
/* prettier-ignore */ export const AUDIO_WILDCARD_KEY = 'Hazard_Key_Use';
/* prettier-ignore */ export const AUDIO_WILDCARD_LOCK_OPEN = 'hazard_lock_open';
/* prettier-ignore */ export const AUDIO_WILDCARD_ANCHOR = 'anchor';
/* prettier-ignore */ export const AUDIO_BOOSTER_SHUFFLE = 'SHUFFLE';
/* prettier-ignore */ export const AUDIO_CARD_DEAL_CARDS = 'Booster_FiveCards_Use';
/* prettier-ignore */ export const AUDIO_BOOSTER_JOKER = 'Booster_Joker_Use';
/* prettier-ignore */ export const AUDIO_BOOSTER_BULLSEYE = 'Bullseye';
/* prettier-ignore */ export const AUDIO_BOOSTER_TNT = 'TNT_individual_explosion';
/* prettier-ignore */ export const AUDIO_BOOSTER_UNDO = 'UndoMove_Use';
/* prettier-ignore */ export const AUDIO_HAZARD_BOMB_EXPLODE = 'Hazard_Bomb_explode';
/* prettier-ignore */ export const AUDIO_HAZARD_BOMB_COUNT = 'Hazardbombcountdown';
/* prettier-ignore */ export const AUDIO_HAZARD_ICE = 'ice_break';
/* prettier-ignore */ export const AUDIO_GOLD_CARD_COLLECT = 'GoldenCard_collect';
/* prettier-ignore */ export const AUDIO_GOLD_CARD_COMPLETED = 'GoldenCard_completed';
/* prettier-ignore */ export const AUDIO_GOLD_CARD_REVEAL = 'GoldenCard_reveal';

/* prettier-ignore */ export const AUDIO_UI_SCORE_BEATEN = 'score_beaten';
/* prettier-ignore */ export const AUDIO_UI_POPUP_OPEN_DEFAULT = 'swoosh1';
/* prettier-ignore */ export const AUDIO_UI_POPUP_CLOSE_DEFAULT = 'swoosh2';
/* prettier-ignore */ export const AUDIO_UI_BUTTON_DEFAULT = 'button_press';
/* prettier-ignore */ export const AUDIO_UI_BUTTON_CLOSE = 'button_X';
/* prettier-ignore */ export const AUDIO_UI_COINS = 'coins_add';
/* prettier-ignore */ export const AUDIO_UI_HEARTS = 'Hearts';
/* prettier-ignore */ export const AUDIO_UI_KEYS = 'Keys';
/* prettier-ignore */ export const AUDIO_UI_3_STAR_REWARD = '3_star_reward';
/* prettier-ignore */ export const AUDIO_UI_STAR_ACHIEVED = 'Star_TOPUIBar_reached_inlevel';
/* prettier-ignore */ export const AUDIO_UI_PRIZE_WHEEL_SPIN = 'Prizewheel_Spin';
/* prettier-ignore */ export const AUDIO_UI_PRIZE_WHEEL_FANFARE = 'PrizeWheel_Win_Song';
/* prettier-ignore */ export const AUDIO_UI_SUITCASE_OPEN = 'suitcase_open';
/* prettier-ignore */ export const AUDIO_UI_SUITCASE_CLOSE = 'suitcase_close';
/* prettier-ignore */ export const AUDIO_UI_UNLOCK_BACKCARD = 'unlock_backcard';
/* prettier-ignore */ export const AUDIO_UI_CAMERA_FLASH = 'camera_flash';

/* prettier-ignore */ export const AUDIO_CHALLENGE_CHEST_OPEN = 'chest_open';
/* prettier-ignore */ export const AUDIO_CHALLENGE_REWARD_POPUP_01 = 'pop_up_01';
/* prettier-ignore */ export const AUDIO_CHALLENGE_REWARD_POPUP_02 = 'pop_up_02';
/* prettier-ignore */ export const AUDIO_CHALLENGE_REWARD_POPUP_03 = 'pop_up_03';
/* prettier-ignore */ export const AUDIO_CHALLENGE_REWARD_POPUP_04 = 'pop_up_04';
/* prettier-ignore */ export const AUDIO_CHALLENGE_REWARD_POPUP_05 = 'pop_up_05';
/* prettier-ignore */ export const AUDIO_CHALLENGE_REWARD_DISAPPEAR_01 = 'pop_dis_01';
/* prettier-ignore */ export const AUDIO_CHALLENGE_REWARD_DISAPPEAR_02 = 'pop_dis_02';
/* prettier-ignore */ export const AUDIO_CHALLENGE_REWARD_DISAPPEAR_03 = 'pop_dis_03';
/* prettier-ignore */ export const AUDIO_CHALLENGE_REWARD_DISAPPEAR_04 = 'pop_dis_04';
/* prettier-ignore */ export const AUDIO_CHALLENGE_REWARD_DISAPPEAR_05 = 'pop_dis_05';
/* prettier-ignore */ export const AUDIO_CHALLENGE_START = 'ticket_challenge_start';
/* prettier-ignore */ export const AUDIO_CHALLENGE_COMPLETE = 'challenge_complete';
/* prettier-ignore */ export const AUDIO_CHALLENGE_AVATAR_JUMP = 'avatar_jump';
/* prettier-ignore */ export const AUDIO_CHALLENGE_TICKET_PURCHASE = 'ticket_purchase';
/* prettier-ignore */ export const AUDIO_CHALLENGE_LEVEL_COMPLETE = 'challenge_level_complete';
/* prettier-ignore */ export const AUDIO_CHALLENGE_LEVEL_START = 'challenge_level_start';

/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_JINGLE = "extra_cards_jingle";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_FIREWORKS = "extra_cards_fireworks";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_WOOSH = "card_whoosh";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_24 = "cards_pop_24";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_23 = "cards_pop_23";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_22 = "cards_pop_22";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_21 = "cards_pop_21";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_20 = "cards_pop_20";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_19 = "cards_pop_19";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_18 = "cards_pop_18";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_17 = "cards_pop_17";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_16 = "cards_pop_16";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_15 = "cards_pop_15";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_14 = "cards_pop_14";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_13 = "cards_pop_13";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_12 = "cards_pop_12";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_11 = "cards_pop_11";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_10 = "cards_pop_10";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_09 = "cards_pop_09";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_08 = "cards_pop_08";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_07 = "cards_pop_07";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_06 = "cards_pop_06";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_05 = "cards_pop_05";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_04 = "cards_pop_04";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_03 = "cards_pop_03";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_02 = "cards_pop_02";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP_01 = "cards_pop_01";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_POP = "pop";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_STAR_1 = "1st_star";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_STAR_2 = "2nd_star";
/* prettier-ignore */ export const AUDIO_WIN_SEQUENCE_STAR_3 = "3rd_star";
